/**
 * Drop query params with no value ("", null, undefined) so requests
 * don't send keys like `sort_val=&start_date=`.
 */
export default function cleanParams(params) {
	return Object.fromEntries(
		Object.entries(params || {}).filter(
			([, value]) => value !== "" && value !== null && value !== undefined
		)
	);
}
